export class Exchange {
  id: number;
  type: number;
  code: string;
  name: string;
  pr_name: string;
  settlement_date_add: number;
  priority: number;
}
